export const SUSPICIOUS_CONTACT_TAG = 'suspicious';

export const PI_LAYER_OUTPUT_FINGERPRINT_TAG = 'pi_layer:output_fingerprint';

export const SPAM_CONTACT_TAGS = [
  SUSPICIOUS_CONTACT_TAG,
  PI_LAYER_OUTPUT_FINGERPRINT_TAG,
] as const;

export const SUSPICIOUS_ACTIVITY_LABEL = 'Actividad sospechosa';

type ContactTagsSource = {
  contact_tags?: string[];
  contact?: { tags?: string[] };
} | null | undefined;

export function getContactTags(chat: ContactTagsSource): string[] {
  if (!chat) return [];
  return chat.contact_tags ?? chat.contact?.tags ?? [];
}

export function hasSuspiciousTag(chat: ContactTagsSource): boolean {
  return getContactTags(chat).includes(SUSPICIOUS_CONTACT_TAG);
}

export function withoutSuspiciousTag(tags: string[]): string[] {
  return tags.filter((tag) => tag !== SUSPICIOUS_CONTACT_TAG);
}
